<dx-popup
  [showTitle]="true"
  [title]="'Ajouter des points de livraison'"
  [(visible)]="displayDialog"
  [width]="'80wh'"
  [maxHeight]="'80vh'"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHidden)="closeDialog()"
>

  <form *ngIf="regroupementPlat" (ngSubmit)="save()" #PlcPrestaForm="ngForm">
    <div class="custom-button-container-right save-container">
      <yo-button
        [disabled]="!canEdit() || selectedPlc.length == 0"
        iconClass="fas fa-save"
        (onClick)="save()"
        tooltip="Enregistrer"
        buttonClass="cta-success">
      </yo-button>
    </div>
    <div class="settings-tables-container">
      <div>
        <div class="label" title="site">Point de livraison<span class="danger-color">*</span> :</div>
        <div class="list-container custom-card-body">
          <yo-tree-list
            #plcList
            key="id"
            displayValue="libelle"
            [data]="allPlc"
            [selectedItems]="selectedPlc"
            (onValueChange)="updateSelectedPlc($event)"
          >
          </yo-tree-list>
        </div>
      </div>
      <div>
        <div class="label" title="prestations">Choix optionnel des prestations :</div>
        <span style="font-style: italic; font-size: 10px">Seules les prestations existantes seront ajoutées sur chaque point de livraison. Cette liste est modifiable</span>
        <div class="list-container custom-card-body">
          <yo-tree-list
            #conviveList
            key="id"
            displayValue="libelle"
            [data]="convives"
            [selectedItems]="selectedConvive"
            (onValueChange)="updateSelectedConvive($event)"
          >
          </yo-tree-list>
        </div>
      </div>
    </div>
  </form>
</dx-popup>
